<template>
  <div id="userRegPan">
    <span class="helloBn"><a @click="dialogVisible = true">免费注册</a></span>
    <el-dialog
      v-model="dialogVisible"
      width="30%"
      v-bind="$attrs"
      @open="onOpen"
      @close="onClose"
      title="用户注册"
      :close-on-click-modal="false"
    >
      <el-row :gutter="15" type="flex" justify="center">
        <el-form
          ref="elForm"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="150px"
        >
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <el-form-item label="账号 (手机号)" prop="userNickName">
                  <el-input
                    v-model="formData.userNickName"
                    placeholder="请输入手机号"
                    :maxlength="11"
                    show-word-limit
                    clearable
                    prefix-icon="el-icon-phone"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="密 码" prop="userPasswd">
                  <el-input
                    v-model="formData.userPasswd"
                    placeholder="请输入密码"
                    clearable
                    prefix-icon="el-icon-key"
                    show-password
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="确认密码" prop="userPasswd2">
                  <el-input
                    v-model="formData.userPasswd2"
                    placeholder="请再次输入密码"
                    clearable
                    prefix-icon="el-icon-key"
                    show-password
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="手机验证码" prop="msgcode">
                  <el-input
                    v-model="formData.msgcode"
                    placeholder="请输入手机验证码"
                    :maxlength="4"
                    show-word-limit
                    clearable
                    prefix-icon="el-icon-info"
                    :style="{ width: '100%' }"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" style="text-align:left;">
                <el-form-item label-width="0" style="margin-left: 10px;">
                  <el-button
                    @click="send"
                    size="small"
                    style=""
                    type="success"
                    :disabled="(disabled = !show)"
                  >
                    <span v-show="show">点我获取手机验证码</span>
                    <span v-show="!show" class="count">{{ count }} s</span>
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item size="large">
                  <el-button @click="resetForm">重置</el-button>
                  <el-button type="primary" @click="submitForm"
                    >提 &nbsp;&nbsp;交</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.userPasswd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    // 用户名唯一校验  查询是否重复
    const testUserValidate = (rule, value, callback) => {
      const uname = this.formData.userNickName
      const api = '/md/front/user/isexist'
      const params = {
        nickName: uname
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          // eslint-disable-next-line no-debugger
          // debugger
          // callback(new Error('此手机号已存在!!'))
          // this.formData.nickName = ''
        } else {
          callback()
        }
      })
    }
    return {
      dialogVisible: false,
      formData: {
        userNickName: '',
        userPasswd: '',
        userPasswd2: '',
        msgcode: ''
      },
      timer: null /* 计时器,注意需要进行销毁  */,
      show: true /* 初始启用按钮 */,
      count: '' /*  初始化次数 */,
      rules: {
        userNickName: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          },
          {
            validator: testUserValidate,
            trigger: 'blur'
          }
        ],
        userPasswd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        userPasswd2: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        msgcode: [
          {
            required: true,
            message: '请输入手机验证码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    onOpen () {},
    onClose () {
      this.dialogVisible = false
      this.$refs.elForm.resetFields()
    },
    isvaliduserPhoneNum (str) {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      return reg.test(str)
    },
    submitForm () {
      // eslint-disable-next-line no-debugger
      // debugger
      /*
      this.$refs.elForm.validate(valid => {
        // eslint-disable-next-line no-debugger
        debugger
        if (!valid) {
          // eslint-disable-next-line no-debugger
          debugger
          // alert('请输入')
          return
        }
        this.doSubmitForm() // 正式提交表单
      })
       */
      this.doSubmitForm() // 正式提交表单
    },
    resetForm () {
      this.$refs.elForm.resetFields()
    },
    send () {
      const tag = this.isvaliduserPhoneNum(this.formData.userNickName)
      if (!tag) {
        this.$message({
          message: '请输入手机号',
          type: 'warning'
        })
        return
      }
      this.doSenduserPhoneNumCode() /* 发送验证码 */
      if (!this.timer) {
        this.count = 60
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer) // 清除定时器
            this.timer = null
          }
        }, 1000)
      }
    },
    doSenduserPhoneNumCode () {
      const tel = this.formData.userNickName
      const api = '/md/front/user/sendmsgcode'
      const params = {
        telNum: tel
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$alert('发送成功', '提示')
        }
      })
    },
    doSubmitForm () {
      const api = '/md/front/user/register'
      const params = this.formData
      delete params.userPasswd2 // 删除某一属性
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          // 注册成功
          this.$alert('注册成功', '提示')
          this.onClose()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.helloBn {
   font-size: 22px;
   cursor: pointer;
   color: #fff;
   top: 5px;
   position: relative;
}

.helloBn a:hover {
  color: crimson;
   top: 5px;
}

#userRegPan :deep(.el-input__inner) {
  color: #000;
}

#userRegPan :deep(.el-form) {
  width: 500px;
}
</style>
